import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'About',
    href: '#about'
  }, {
    name: 'Approach',
    href: '#approach'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'Testimonials',
    href: '#testimonials'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-charcoal-950/95 backdrop-blur-md py-4 shadow-lg' : 'bg-transparent py-6'}`} data-id="element-230" data-mp="1q0nrrpl05xo7">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-231" data-mp="9o7thw3et8kr">
        <a href="#" className="text-2xl font-bold text-offwhite-50 tracking-tight" data-id="element-232" data-mp="elzjgkkhukmb">
          McLean <span className="text-amber-500" data-id="element-233" data-mp="jkkk2l3nr6ba">PT</span>
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center space-x-8" data-id="element-234" data-mp="okyto7kwqobf">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-offwhite-100 hover:text-amber-500 transition-colors text-sm font-medium" data-id="element-235" data-mp="3n19ifjt379pv">
              {link.name}
            </a>)}
          <a href="https://calendly.com/dylanmclean-mcleanphysicaltherapy/consult-call" target="_blank" rel="noopener noreferrer" className="bg-amber-500 hover:bg-amber-400 text-charcoal-950 px-6 py-2.5 rounded-full font-semibold transition-all transform hover:scale-105" data-id="element-236" data-mp="5ne22sqrdbn4">
            Book a Consult
          </a>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-offwhite-50" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-237" data-mp="2wbf2eamp86fv">
          {isMobileMenuOpen ? <XIcon size={28} data-id="element-238" data-mp="3629rrnv8rm5j" /> : <MenuIcon size={28} data-id="element-239" data-mp="361q7w1m16nov" />}
        </button>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence data-id="element-240" data-mp="2ibvu9htw0v3k">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-charcoal-900 border-t border-charcoal-800" data-id="element-241" data-mp="2iei2zksilgnd">
            <div className="flex flex-col px-6 py-4 space-y-4" data-id="element-242" data-mp="7it27z52mafj">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-offwhite-100 hover:text-amber-500 text-lg font-medium py-2" data-id="element-243" data-mp="2kzydcr8psif">
                  {link.name}
                </a>)}
              <a href="https://calendly.com/dylanmclean-mcleanphysicaltherapy/consult-call" target="_blank" rel="noopener noreferrer" className="bg-amber-500 text-charcoal-950 px-6 py-3 rounded-lg font-semibold text-center mt-4" data-id="element-244" data-mp="55pjv01le5ch">
                Book a Consult
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}